import React from 'react'

export default function EnvBar({ color }) {
  return <div className="absolute z-[999] h-[5px] w-full" style={{ backgroundColor: color }} />
}
